import React, { FunctionComponent } from "react";
import { useAnimation } from "../../hooks/useAnimate";
import Section from "../layout/Section";
import BodyText from "../typography/BodyText";
import { TitleHeading } from "../typography/TitleHeading";
import { Pattern } from "../Pattern";

type SideTextSectionProps = {
  tag: string;
  title: JSX.Element | string;
  text?: string | React.ReactNode;
};

const SideTextSection: FunctionComponent<SideTextSectionProps> = ({
  tag,
  title,
  text,
  children,
}) => {
  const { id, animate } = useAnimation();

  return (
    <Section id={id} theme="gray">
      <div
        {...animate("fade-right")}
        className="w-full md:w-10/12 xl:w-7/12 z-50"
      >
        <TitleHeading tag={tag} title={title} />
        <BodyText className="text-justify mt-6" mb="6">
          {text}
        </BodyText>
        {children}
      </div>
      <Pattern
        type="square"
        className={`hidden xl:block absolute h-full w-3/12 -top-12 right-24 text-gray-200 dark:text-gray-800 opacity-70 -z-20`}
      />
    </Section>
  );
};

export default SideTextSection;
